export const DEMAND_SOURCE = {
  ESTATE_CALCULATOR_BANNER: 'estate_calculator_banner',
};
